module.exports = __webpack_public_path__ + "img/kefu.ed5110a1.png";